import { useTranslation } from 'react-i18next';
import { screen, colors } from 'components/styles/variables';
import Link from 'next/link';
import ParentCategory from 'lib/ParentCategory';
import { RelatedSlideshow } from 'types/Slideshow';
import { trackCtaClick } from 'lib/Tracking';
import { ArticleInterface } from 'types/Apis/ArticleInterface';
import { EventsDataInterface } from './types';
import RelatedItem from './RelatedItem';

interface RelatedArticlesProps {
  related: (ArticleInterface | RelatedSlideshow)[];
  eventsData: EventsDataInterface;
  parentCategoryName: string;
  isSlideshow?: boolean;
}

const RelatedArticles = ({
  related = [],
  eventsData,
  parentCategoryName,
  isSlideshow,
}: RelatedArticlesProps): JSX.Element => {
  const { t } = useTranslation();
  const category = new ParentCategory(parentCategoryName);
  return (
    <div>
      <div className="related-header">
        <h3 className="related-stories">{t('article.related')}</h3>
        <Link href={category.link}>
          <a className="view-all-stories">
            {t(category.translationKey)}
            {` `}
            <span className="right-caret">^</span>
          </a>
        </Link>
      </div>
      <ul className="related-articles-list">
        {related.map((article) => (
          <RelatedItem
            isSlideshow={isSlideshow}
            eventsData={eventsData}
            article={article}
            key={article.title}
          />
        ))}
      </ul>
      <Link href={category.link}>
        <a
          className="view-all-stories-bottom"
          onClick={(): void => {
            trackCtaClick(eventsData.categoryName, eventsData.pageName, category.link);
          }}
        >
          {t(category.translationKey)}
          {` `}
          <span className="right-caret">^</span>
        </a>
      </Link>
      <style jsx>{`
        .related-header .view-all-stories {
          display: none;
        }

        .view-all-stories-bottom {
          margin: 0;
          font-weight: 700;
          color: ${colors.ALR1};
          display: block;
          text-transform: uppercase;
          padding-bottom: 20px;
          font-size: 16px;
        }
        .view-all-stories {
          margin: 0;
          font-size: 14px;
          font-weight: 700;
          text-transform: uppercase;
          color: ${colors.ALR1};
        }
        .related-articles-list {
          list-style: none;
          padding: 0;
          width: 100%;
          margin-bottom: 10px;
        }
        .related-stories {
          margin: 0;
          font-size: 26px;
        }

        .right-caret {
          display: inline-block;
          transform: rotate(90deg);
        }

        @media screen and (min-width: ${screen.smMin}) {
          .related-articles-list {
            list-style: none;
            padding: 0;
            display: flex;
            width: 100%;
            margin-top: 10px;
          }

          .related-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .related-header .view-all-stories {
            display: block;
          }

          .view-all-stories-bottom {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default RelatedArticles;
